// @flow

import styled, { css } from 'styled-components';

export const PaymentMethodsGroup = styled.div`
  border-radius: 5px;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
  ${props => props.focused && css`
    box-shadow: 0 0 3px 1px ${props => props.theme.colors.primary(50)};
  `}
  color: ${props => props.theme.colors.primary(10)};
  transition: 1s ease-in-out all;
`;
